/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import CommandPalette from './CommandPalette';
import GlobalPendingFeedbackAlert from './GlobalPendingFeedbackAlert';
import GlobalToolbox from './GlobalToolbox';
import ImageUpload from './ImageUpload';
import {
  AdminRegionSwitcher,
  CurrentGroupBadge,
  CurrentTenantCacheClearButton,
  ProductSwitcher,
  Question,
  SelectLang,
} from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AdminRegionSwitcher,
  AvatarDropdown,
  AvatarName,
  CommandPalette,
  CurrentGroupBadge,
  CurrentTenantCacheClearButton,
  Footer,
  GlobalPendingFeedbackAlert,
  GlobalToolbox,
  ImageUpload,
  ProductSwitcher,
  Question,
  SelectLang,
};
